import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const Download = () => {
    useEffect(() => {
        window.location.replace('https://sd.vent.africa/mobile');
    }, []);
  return (
    <div>
        <Helmet>
            <title>Download App - Vent Africa: Swap Crypto for Cash</title>
            <meta name="title" content="Download App - Vent Africa: Swap Crypto for Cash" />
            <meta name="description" content="Crypto to Cash Made Easy, Convert Your Crypto to Cash, Instant Payment, Zero Charge, Download Vent App." />
            
            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://vent.africa/" />
            <meta property="og:title" content="Download App - Vent Africa: Swap Crypto for Cash" />
            <meta property="og:description" content="Crypto to Cash Made Easy, Convert Your Crypto to Cash, Instant Payment, Zero Charge, Download Vent App." />
            <meta property="og:image" content="img/app.png" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content="https://vent.africa/" />
            <meta property="twitter:title" content="Download App - Vent Africa: Swap Crypto for Cash" />
            <meta property="twitter:description" content="Crypto to Cash Made Easy, Convert Your Crypto to Cash, Instant Payment, Zero Charge, Download Vent App." />
            <meta property="twitter:image" content="img/app.png" />
        </Helmet>
    </div>
  )
}

export default Download;